import '../../style/index.less'
import './index.less'

// style dependencies
import '../../checkbox/style'



// WEBPACK FOOTER //
// ./components/tree/style/index.js